<template>
  <div class="footer-bar">
    <div class="inner-footer" style="background-color: gray;"> </div>
    <div class="inner-footer" style="background-color: lightblue;"> </div>
    <div class="inner-footer" style="background-color: orange;"> </div>
    <div class="inner-footer" style="background-color: yellow;"> </div>
  </div>
</template>

<script>
    export default {
        name: 'FooterBar'
    }
</script>

<style scoped>

  .footer-bar {
    width: 100%;
  }

  .inner-footer {
    display:inline-block;
    width: 25%;
    height: 2px;
  }

</style>
